/* PetArmor A+ live text: variant-following boards (Sep 1 2026).
   Rides the theme's global "cc-variant-updated" jQuery event
   (assets/theme.js, _onSelectChange). Boards opt in with
   data-show-for="Option value, Option value" (board hidden unless the
   selected variant carries one of the listed option values) and
   data-aplus-weight (attribute mirrors the selected weight option value;
   the CSS swaps the pack-render background off it). Server-side Liquid
   sets the initial state, so this file only handles changes. */
(function () {
  function apply(variant) {
    if (!variant || !variant.options) return;
    var opts = variant.options;
    var boards = document.querySelectorAll('[data-show-for]');
    for (var i = 0; i < boards.length; i++) {
      var list = boards[i].getAttribute('data-show-for').split(',');
      var show = false;
      for (var j = 0; j < list.length; j++) {
        if (opts.indexOf(list[j].trim()) !== -1) { show = true; break; }
      }
      boards[i].hidden = !show;
    }
    var weighted = document.querySelectorAll('[data-aplus-weight]');
    for (var k = 0; k < weighted.length; k++) {
      for (var m = 0; m < opts.length; m++) {
        if (/lbs$/i.test(opts[m])) {
          weighted[k].setAttribute('data-aplus-weight', opts[m]);
          break;
        }
      }
    }
  }
  function bind() {
    if (window.jQuery) {
      window.jQuery(window).on('cc-variant-updated', function (evt, data) {
        apply(data && data.variant);
      });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else { bind(); }
})();
